import { render, staticRenderFns } from "./repairReception.vue?vue&type=template&id=686a63d5&"
import script from "./repairReception.vue?vue&type=script&lang=js&"
export * from "./repairReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports